const teams = Array.from(document.querySelectorAll("[data-team-name]"));
const teamSearch = document.querySelector("[data-team-search]");

const teamsArr = teams.map((team) => {
  return team.dataset.teamName;
});

const options = {
  shouldSort: true,
  threshold: 0.3,
};

const fuse = new Fuse(teamsArr, options);

teamSearch.addEventListener("keyup", function (e) {
  if (e.target.value !== "") {
    const result = fuse.search(e.target.value);
    console.log(result);

    teams.forEach((team) => {
      team.classList.add("hide");
    });

    result.forEach((item) => {
      teams.forEach((team) => {
        if (team.dataset.teamName === item.item) {
          team.classList.remove("hide");
        }
      });
    });
  } else {
    teams.forEach((team) => {
      team.classList.remove("hide");
    });
  }
});
